import {denormFn, normFn} from '../normalizerSupport';
import * as Types from './types';

export const normalize = normFn<Types.SortObjSchema>('sort', whole => whole);

export const denormalize = denormFn<Types.SortObjSchema>(part => part);
